export default __webpack_public_path__ + "static/media/10.7a0c9ba0.jpg";